export const PanoramaLogoText = () => (
  <span className="text-xl font-thin" style={{ fontFamily: "'Montserrat Alternates', sans-serif" }}>
    Panorama<span className="ml-0.5 align-super text-xs">®</span>
  </span>
)
